import styled, { CSSObject } from '@emotion/styled'
import { StyledHTMLElement } from 'shop/theme/types'

const FulfillmentPrefix = styled.div<StyledHTMLElement>(
  (): CSSObject => ({
    color: '#59595A'
  })
)

export { FulfillmentPrefix }
